import { render, staticRenderFns } from "./AgentMerchantCollect.vue?vue&type=template&id=68e7dd50&scoped=true&"
import script from "./AgentMerchantCollect.vue?vue&type=script&lang=js&"
export * from "./AgentMerchantCollect.vue?vue&type=script&lang=js&"
import style0 from "./AgentMerchantCollect.vue?vue&type=style&index=0&id=68e7dd50&scoped=true&lang=css&"
import style1 from "./AgentMerchantCollect.vue?vue&type=style&index=1&id=68e7dd50&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7dd50",
  null
  
)

export default component.exports